import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9d60a624"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "value", "name", "checked"]
const _hoisted_2 = ["for", "innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "form-check form-check-inline",
    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)), ["stop"]))
  }, [
    _createElementVNode("input", {
      id: _ctx.$attrs.id,
      ref: "checkbox",
      class: "form-check-input",
      type: "radio",
      value: _ctx.label,
      name: _ctx.$attrs.name,
      checked: _ctx.isChecked,
      onChange: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleOnInput && _ctx.handleOnInput(...args)), ["stop"]))
    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_1),
    _createElementVNode("label", {
      class: _normalizeClass([_ctx.$attrs['label-classes'], "form-check-label"]),
      for: _ctx.$attrs.id,
      innerHTML: _ctx.label
    }, null, 10 /* CLASS, PROPS */, _hoisted_2)
  ]))
}